export default "__VITE_ASSET__CmtYsOcA__"